import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getMe } from "../lib/api";

// Module-level cache: avoid /auth/me being called 5+ times when navigating
// between admin routes. Cache valid for 5 minutes.
const AUTH_CACHE_MS = 5 * 60 * 1000;
let cachedAuth = null;
let cachedAt = 0;
let inflight = null;

async function checkAuthCached() {
  const now = Date.now();
  if (cachedAuth && (now - cachedAt) < AUTH_CACHE_MS) return cachedAuth;
  if (inflight) return inflight;
  inflight = (async () => {
    try {
      const res = await getMe();
      cachedAuth = res.data || true;
      cachedAt = Date.now();
      return cachedAuth;
    } finally {
      inflight = null;
    }
  })();
  return inflight;
}

export function clearAuthCache() {
  cachedAuth = null;
  cachedAt = 0;
}

export default function ProtectedRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        navigate("/login");
        return;
      }
      try {
        await checkAuthCached();
        if (!cancelled) setAuthenticated(true);
      } catch {
        localStorage.removeItem("token");
        clearAuthCache();
        if (!cancelled) navigate("/login");
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    run();
    return () => { cancelled = true; };
  }, [navigate]);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-[#FF007F] border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return authenticated ? children : null;
}
